"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkout = void 0;
var _react = _interopRequireDefault(require("react"));
var _wbmInputs = require("wbm-inputs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var Checkout = exports.Checkout = function Checkout(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var getCheckoutUrl = function getCheckoutUrl() {
    var checkoutUrl = '';
    if (props.hasItemAgreements) {
      checkoutUrl = "".concat(props.ecomBaseUrl, "ShoppingCart.aspx");
    } else {
      if (props.configProps.usePunchout) {
        checkoutUrl = "".concat(props.ecomBaseUrl, "Punchout.aspx");
      } else if (props.checkoutAppUri && props.configProps.enableSinglePageCheckout) {
        checkoutUrl = props.checkoutAppUri;
      } else {
        checkoutUrl = "".concat(props.ecomBaseUrl, "ShippingAddress.aspx");
      }
    }
    return checkoutUrl;
  };
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: getCheckoutUrl()
  }, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "btn btn-primary"
  }, "CHECKOUT"));
};
//# sourceMappingURL=Checkout.js.map